import api from "@/lib/axios";

import {
  CreateMarketplaceProfileTestimonialPayload,
  MarketplaceProfileTestimonial,
} from "../types/marketplace-testimonials";

export enum MarketplaceTestimonialsKeys {
  GET_TESTIMONIALS = "marketplace-testimonials",
  GET_TESTIMONIAL = "marketplace-testimonial",
}

export const getMarketplaceProfileTestimonials = async (
  profileId: string,
): Promise<MarketplaceProfileTestimonial[]> => {
  const response = await api.get<MarketplaceProfileTestimonial[]>(
    `/marketplace-profiles/${profileId}/testimonials`,
  );
  return response.data;
};

export const getMarketplaceProfileTestimonial = async (
  profileId: string,
  testimonialId: string,
): Promise<MarketplaceProfileTestimonial> => {
  const response = await api.get<MarketplaceProfileTestimonial>(
    `/marketplace-profiles/${profileId}/testimonials/${testimonialId}`,
  );
  return response.data;
};

export const createMarketplaceProfileTestimonial = async (
  profileId: string,
  payload: CreateMarketplaceProfileTestimonialPayload,
): Promise<MarketplaceProfileTestimonial> => {
  const response = await api.post<MarketplaceProfileTestimonial>(
    `/marketplace-profiles/${profileId}/testimonials`,
    payload,
  );
  return response.data;
};

export const deleteMarketplaceProfileTestimonial = async (
  profileId: string,
  testimonialId: string,
): Promise<void> => {
  await api.delete(
    `/marketplace-profiles/${profileId}/testimonials/${testimonialId}`,
  );
};
